/** Инициалы из имени: первые буквы первых двух слов, капсом. Без имени — пустая строка. */
export function getInitials(name?: string): string {
  if (!name) return ''

  return name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join('')
}
